import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output
       } from '@angular/core';
import { Icons } from 'core/icons';
import { TextAlignment } from '../../text/text.model';

@Component({
    selector: 'text-alignment-chooser',
    templateUrl: './text-alignment-chooser.component.html',
    styleUrls: ['./text-alignment-chooser.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextAlignmentChooserComponent
{
  @Input('alignment') public alignment: TextAlignment;
  @Output() public alignmentChange: EventEmitter<TextAlignment> =
    new EventEmitter();

  public readonly textAlignment: any = TextAlignment;
  public alignLeftUrl: string = Icons.url('align-left');
  public alignMiddleUrl: string = Icons.url('align-center');
  public alignRightUrl: string = Icons.url('align-right');

  public setAlignment(newAlignment: TextAlignment): void
  {
    this.alignment = newAlignment;
    this.alignmentChange.emit(newAlignment);
  }
}
